import ChatInput from '@/features/chat/blocks/chatInput/chatInput';

export default ChatInput;
